define( [
	"./arr"
], function( arr ) {
	return arr.push;
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/var/push.js
// module id = 641
// module chunks = 214